webpackJsonp([114276838955818,60335399758886],{

/***/ 194:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(302);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(194);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9Ijg1cHgiIGhlaWdodD0iODVweCIgdmlld0JveD0iMCAwIDgwIDgwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA4MCA4MCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cgk8Zz4KCQk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNNDAsMGMyMi4wOTEsMCw0MCwxNy45MDksNDAsNDBTNjIuMDkxLDgwLDQwLDgwUzAsNjIuMDkxLDAsNDBTMTcuOTA5LDAsNDAsMHoiLz4KCTwvZz4KCTxnPgoJCTxwYXRoIGZpbGw9IiM4Y2M5ZjAiIGQ9Ik01MC4zNzgsMzIuNTc2YzAsMS4wMDUtMC44MTUsMS44MjEtMS44MjEsMS44MjFjLTEuMDA1LDAtMS44Mi0wLjgxNi0xLjgyLTEuODIxCgkJCWMwLTEuMDA1LDAuODE1LTEuODIxLDEuODItMS44MjFDNDkuNTYzLDMwLjc1NSw1MC4zNzgsMzEuNTcxLDUwLjM3OCwzMi41NzZ6IE01NC42MjcsMjcuMTEzYzAtMC4zNDEtMC4zMDQtMC42MDctMC42NDYtMC42MDcKCQkJYy02LjYwMSwwLTEwLjIyMywxLjUxOC0xNC45NjQsNi4yNDFjLTEuMDgxLDEuMS0yLjIsMi4zNTItMy4zMzgsMy42OTlsLTcuMTg4LDAuMzc5Yy0wLjE5LDAuMDE5LTAuMzc5LDAuMTMzLTAuNDkzLDAuMzA0CgkJCWwtNC4yNDksNy4yODRjLTAuMTMzLDAuMjI4LTAuMDk1LDAuNTMsMC4wOTUsMC43MzlsMS4yMTQsMS4yMTVjMC4xMTQsMC4xMTMsMC4yODUsMC4xNywwLjQzNywwLjE3YzAuMDU3LDAsMC4xMTQsMCwwLjE3LTAuMDIKCQkJbDUuMjM1LTEuNjExbDUuMzMsNS4zM2wtMS42MTIsNS4yMzZjLTAuMDU3LDAuMjA5LDAsMC40MzcsMC4xNTIsMC42MDZsMS4yMTQsMS4yMTRjMC4xMzMsMC4xMTQsMC4yODQsMC4xNzEsMC40MzYsMC4xNzEKCQkJYzAuMTE0LDAsMC4yMDgtMC4wMjEsMC4zMDQtMC4wNzVsNy4yODMtNC4yNWMwLjE3MS0wLjExMywwLjI4NC0wLjMwNCwwLjMwNS0wLjQ5MmwwLjM3OS03LjE5YzEuMzQ3LTEuMTM4LDIuNTk5LTIuMjU3LDMuNjk5LTMuMzM5CgkJCUM1Mi44ODIsMzcuNjAzLDU0LjYyNywzMy40MTEsNTQuNjI3LDI3LjExM3oiLz4KCTwvZz4KPC9zdmc+"

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(41);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(127);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        'footer',
	        { id: 'footer' },
	        _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Contact'
	            ),
	            _react2.default.createElement(
	                'dl',
	                { className: 'alt' },
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Adresa'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    'Strada Constantin Noica nr. 140 ',
	                    _react2.default.createElement('br', null),
	                    'Bucuresti, Sector 6, 060057, Romania'
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Telefon'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    ' (004) 0722.367.456'
	                ),
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Email'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    null,
	                    ' ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#' },
	                        'raresuniv@yahoo.com'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'ul',
	                { className: 'icons' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'http://www.unefsb.ro', className: 'icon fa-globe  alt' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'label' },
	                            'Website'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'copyright' },
	            '\xA9 UNEFS Erasmus+ Online SignUp '
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(41);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(452);
	
	var _Footer = __webpack_require__(292);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      loading: 'is-loading'
	    };
	    return _this;
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.timeoutId = setTimeout(function () {
	      _this2.setState({ loading: '' });
	    }, 100);
	  };
	
	  Template.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timeoutId) {
	      clearTimeout(this.timeoutId);
	    }
	  };
	
	  Template.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'body ' + this.state.loading },
	      _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        children(),
	        _react2.default.createElement(_Footer2.default, null)
	      )
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.func
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-0ef7e5f5d0da40c2ef95.js